import { Box, Chip } from "@mui/material";
import React from "react";
import { ICustomChipProps } from "./interfaces/ICustomChipProps";
import { CustomFormLabel } from "../formsComponents";

export const CustomChip: React.FC<ICustomChipProps> = (props) => {
  const { size, content, color, icon, sx } = props;

  // Custom styling for different color variants
  const getChipStyles = () => {
    let colorStyles = {};

    switch (color) {
      case "success":
        colorStyles = {
          backgroundColor: "#e8f5e8", // Light green background
          color: "#2e7d32", // Solid green text
          border: "1px solid #c8e6c9", // Subtle border
          "&:hover": {
            backgroundColor: "#d4edda",
            boxShadow: "0 2px 6px rgba(46, 125, 50, 0.15)",
          },
        };
        break;
      case "error":
        colorStyles = {
          backgroundColor: "#ffebee", // Light red background
          color: "#c62828", // Solid red text
          border: "1px solid #ffcdd2",
          "&:hover": {
            backgroundColor: "#fce4ec",
            boxShadow: "0 2px 6px rgba(198, 40, 40, 0.15)",
          },
        };
        break;
      case "warning":
        colorStyles = {
          backgroundColor: "#fff3e0", // Light orange background
          color: "#ef6c00", // Solid orange text
          border: "1px solid #ffe0b2",
          "&:hover": {
            backgroundColor: "#ffeaa7",
            boxShadow: "0 2px 6px rgba(239, 108, 0, 0.15)",
          },
        };
        break;
      case "info":
        colorStyles = {
          backgroundColor: "#e3f2fd", // Light blue background
          color: "#1565c0", // Solid blue text
          border: "1px solid #bbdefb",
          "&:hover": {
            backgroundColor: "#e1f5fe",
            boxShadow: "0 2px 6px rgba(21, 101, 192, 0.15)",
          },
        };
        break;
      case "primary":
        colorStyles = {
          backgroundColor: "#e8eaf6", // Light purple background
          color: "#3f51b5", // Solid purple text
          border: "1px solid #c5cae9",
          "&:hover": {
            backgroundColor: "#f3e5f5",
            boxShadow: "0 2px 6px rgba(63, 81, 181, 0.15)",
          },
        };
        break;
      default:
        colorStyles = {
          backgroundColor: "#f5f5f5", // Light gray background
          color: "#333", // Dark gray text
          border: "1px solid #e0e0e0",
          "&:hover": {
            backgroundColor: "#eeeeee",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
          },
        };
        break;
    }

    return {
      borderRadius: "8px",
      padding: "3px 4px",
      fontSize: size === "small" ? "10px" : "14px",
      fontWeight: 500,
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      "&.MuiChip-root": {
        display: "flex",
        gap: 2,
      },
      ...colorStyles,
      ...sx,
    };
  };

  return (
    <Chip
      sx={getChipStyles()}
      //@ts-ignore
      icon={icon}
      color={color}
      size={size}
      label={content}
    />
  );
};

export const CustomChipWithLabel: React.FC<{
  title?: string;
  value: string;
  variant?: "h6";
  size?: "small" | "medium";
}> = (props) => {
  const { title, value, variant, size } = props;
  return (
    <>
      <CustomFormLabel>{title}</CustomFormLabel>
      <Chip
        sx={{
          backgroundColor: "primary.main",
          color: "#fff",
          borderRadius: 1,
          fontWeight: 600,
          padding: "5px 8px",
          // width: '100%'
          // minHeight: 30,
        }}
        label={value}
        content={value}
        size={size}
      />
    </>
  );
};
